import React, { FC, Fragment } from 'react';
import { Box, Text, Checkbox } from '@bechtel/gds';
import { FieldProps } from 'formik';
import { ListSelectionStyled, DrawerSubHeaderStyled } from '@bechtel/client-common';
import { Trans } from '@lingui/macro';
import { PriorityWeldIcon } from '~/components/atoms';

export const PriorityWeld: FC<FieldProps> = ({ form }) => {
  return (
    <Fragment>
      <DrawerSubHeaderStyled>
        <Box alignItems={{ sm: 'center' }}>
          <PriorityWeldIcon />
          <Box ml={{ sm: '400' }}>
            <Trans>Priority Welds</Trans>
          </Box>
        </Box>
      </DrawerSubHeaderStyled>
      <ListSelectionStyled
        data-testid="weld-priority"
        onClick={() => {
          form.setFieldValue('isPriority', !form.values.isPriority);
        }}
      >
        <Box mr={{ sm: '500' }}>
          <Checkbox checked={form.values.isPriority === true} readOnly />
        </Box>
        <Text color="bechtel.colors.grey.1000" size="400">
          <Trans>Yes</Trans>
        </Text>
      </ListSelectionStyled>
    </Fragment>
  );
};
